import React from "react";
import AddCoin from "../components/AddCoin";
import CoinList from "../components/CoinList";
import image from '../currencycat.png'
import { Link } from "react-router-dom";
import ReplyIcon from '@material-ui/icons/Reply';
const App = () => {
  return (
    <React.Fragment>
    <Link to={'/'} className="ml-auto p-5"><ReplyIcon className="pb-2" style={{fontSize:'x-large'}}/> <span style={{fontSize:'large'}}>Back</span></Link>
    <div className="coinsummary text-center">
       <img src={image} style={{width:'150px'}}/>
      <AddCoin />
      <CoinList />
    </div>
    </React.Fragment>
  );
};

export default App;
